import { doNothing } from "@edgetier/utilities";
import { TimePeriodGroupBy } from "@edgetier/watchtower-types";
import { createContext } from "react";
import { IExploreContext } from "./explore-context.types";

export const defaultContext: IExploreContext = {
    chartGroupBy: TimePeriodGroupBy.Days,
    setChartGroupBy: doNothing,
};

export const ExploreContext = createContext(defaultContext);
